import { render, staticRenderFns } from "./catCalendarAFSDetail.vue?vue&type=template&id=2f68a844"
import script from "./catCalendarAFSDetail.vue?vue&type=script&lang=js"
export * from "./catCalendarAFSDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports